import React from "react";
import Hero from "../components/Hero";
import ClientsStrip from "../components/ClientsStrip";
import ServicesGrid from "../components/ServicesGrid";
import ProcessSteps from "../components/ProcessSteps";
import Testimonials from "../components/Testimonials";
import CtaBand from "../components/CtaBand";
import Marquee from "../components/Marquee";
import { images, values } from "../mock";
import SectionHeading from "../components/SectionHeading";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const MARQUEE_ITEMS = [
  "AIX 7.3",
  "PowerVM",
  "PowerHA SystemMirror",
  "Dual-VIOS",
  "Live Partition Mobility",
  "GLVM replication",
  "NPIV",
  "JFS2 tuning",
  "Power10 migrations",
  "nmon performance",
  "Shared storage pools",
  "Cross-site clustering"
];

export default function HomePage() {
  return (
    <>
      <Hero />
      <ClientsStrip />

      {/* Infinite tech marquee */}
      <section className="py-8 bg-white border-b border-slate-100">
        <Marquee
          items={MARQUEE_ITEMS}
          speed={55}
          className="font-display text-2xl lg:text-3xl font-semibold text-slate-800"
        />
      </section>

      <ServicesGrid />

      {/* Why BrainWave section */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 relative">
            <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-xl">
              <img src={images.serversRack} alt="Server rack" className="w-full h-[520px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-transparent to-transparent" />
            </div>
            <div className="hidden sm:block absolute -bottom-8 -right-6 glass rounded-2xl p-5 shadow-xl w-[260px]">
              <div className="text-[11px] uppercase tracking-widest text-brand-700">Weekend cutover</div>
              <div className="font-display text-xl mt-1 text-slate-900">Power7 → Power10</div>
              <div className="mt-3 flex gap-2 text-xs text-slate-600">
                <span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 font-medium">0 s downtime</span>
                <span className="px-2 py-0.5 rounded-full bg-brand-100 text-brand-800 font-medium">14 LPARs</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <SectionHeading
              eyebrow="Why BrainWave"
              title="Senior engineers. Boring cutovers. Clear documentation."
              description="We built BrainWave around the idea that mission-critical work shouldn’t be exciting. It should be planned, peer-reviewed and predictable."
              align="left"
            />
            <div className="mt-8 grid sm:grid-cols-2 gap-5">
              {values.map((v, i) => (
                <div key={i} className="rounded-xl border border-slate-200 p-5 bg-white hover-lift">
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="h-5 w-5 text-brand-600" />
                    <div className="font-semibold text-slate-900">{v.title}</div>
                  </div>
                  <p className="mt-2 text-[14px] leading-relaxed text-slate-600">{v.text}</p>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <Link to="/about">
                <Button variant="outline" className="rounded-full h-11 px-6 border-slate-300 hover:border-brand-500 hover:text-brand-700">
                  About our team
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ProcessSteps />
      <Testimonials />
      <CtaBand />
    </>
  );
}
